import { TypeChecker } from '@attain-apps/type-guards'

import * as common from '../../common'

/**
 * A `chglr008` `Bud_ref` value, which `COMBO1` and `COMBO2` are built from: a
 * whole number as plain digits (`1`), or the cell's text when it is not one.
 */
export type BudRef = string
export namespace BudRef {
  export const isBudRef: TypeChecker<BudRef> = TypeChecker.isString

  /**
   * Parses a `Bud_ref` cell, or `undefined` when it is blank.
   *
   * A handful of rows carry a blank (space-only) `Bud_ref` for projects with
   * no budget-year segmentation; those stay blank rather than becoming `0`.
   */
  export function from(cell: unknown): BudRef | undefined {
    const number = common.SheetRow.parseOptionalNumber(cell)
    return number !== undefined && Number.isInteger(number) && number >= 0
      ? String(number)
      : common.SheetRow.cellText(cell)
  }

  /**
   * `Bud_ref` as written in `COMBO2`: a whole number zero-padded to two
   * digits, or the value unchanged when it is not a whole number.
   */
  export function twoDigit(budRef: BudRef): string {
    return _isDigits(budRef) ? unpadded(budRef).padStart(2, '0') : budRef
  }

  /**
   * `Bud_ref` as written in `COMBO1`: a whole number without padding (`1`, not
   * `01`), or the value unchanged when it is not a whole number.
   */
  export function unpadded(budRef: BudRef): string {
    return _isDigits(budRef) ? String(Number(budRef)) : budRef
  }

  /** Whether the value is a whole number written as plain digits. */
  function _isDigits(budRef: BudRef): boolean {
    return /^\d+$/.test(budRef)
  }
}
